export default "__VITE_ASSET__f074b279__"